import React, { useState, useEffect } from 'react';

import Header from 'components/Header';
import Main from 'components/Main';

import * as F from 'fetch';

import StyledApp from './styledApp';

if (!localStorage.metric) {
  localStorage.metric = "°С"
}

const App = () => {
  const [isSearch, setIsSearch] = useState(false);
  const [isCelsius, setIsCelsius] = useState(localStorage.metric === "°С");
  const [isFetch, setIsFetch] = useState(false);
  const [bgImage, setBgImage] = useState('');
  const [region, setRegion] = useState('');
  const [wether, serWeather] = useState(null);
  const [map, setMap] = useState(null);
  const [geoData, setGeoData] = useState(null);
  const [tLocation, setTLocation] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    F.getMyGeolocation(setGeoData, setError);
  }, []);

  useEffect(() => {
    if (isFetch) {
      return;
    }
    if (geoData && geoData.lat) {
      setIsFetch(true);
      const wait = async () => {
        await F.getOpencageData(isSearch, region, geoData, setGeoData, setTLocation, setError);
        setIsSearch(false);
        setIsFetch(false);
      };
      wait();
    }
  }, [region, geoData]);

  useEffect(() => {
    if (geoData && geoData.location) {
      F.getWeather(geoData, serWeather, setError);
      F.getBGImage(geoData, setBgImage, setError);
    }
  }, [geoData]);

  return (
    <StyledApp bgImage={bgImage}>
      <Header
        setBgImage={setBgImage}
        geoData={geoData}
        setIsSearch={setIsSearch}
        setRegion={setRegion}
        setIsCelsius={setIsCelsius}
        setTLocation={setTLocation}
        error={error}
      />
      <Main isCelsius={isCelsius} geoData={geoData} wether={wether} map={map} setMap={setMap} tLocation={tLocation} />
    </StyledApp>
  );
};

export default App;
